export const APPLE_STORE_ADDRESS =
  'https://apps.apple.com/kr/app/%EC%9D%BC%EC%9C%A1%EA%B3%B5-160-%EA%B3%B5%EB%AA%A8%EC%A3%BC-%ED%88%AC%EC%9E%90%EC%9D%98-%ED%99%95%EB%A5%A0%EC%9D%84-%EB%86%92%EC%9D%B4%EB%8B%A4/id1626450484'
export const ANDROID_STORE_ADDRESS =
  'https://play.google.com/store/apps/details?id=com.qniverse.ipo'
